import { useTranslation } from 'react-i18next';

import { PageLayout, PageTitle } from 'core/components';
import { QuotesDashboard } from 'reports/components';

export const QuotesDashboardPage = () => {
  const { t } = useTranslation();

  const title = t('titleDashboard');

  return (
    <PageLayout scrollable title={title}>
      <PageTitle title={title} />
      <QuotesDashboard />
    </PageLayout>
  );
};
